import {openResourceModal} from '../../core/modalCommand';
import {reportActiveAgentModalLifecycle} from '../../core/modalLifecycle';
import {
	SYSTEM_BACKUP_CREATE_MODAL_EVENT,
	SYSTEM_BACKUP_DELETE_MODAL_EVENT,
	SYSTEM_BACKUP_RESTORE_MODAL_EVENT,
	SYSTEM_BACKUP_UPLOAD_MODAL_EVENT,
} from './events';

/**
 * Open the Create Backup form on System Backup.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSystemBackupCreateModal(command, envelope) {
	return openResourceModal(
		SYSTEM_BACKUP_CREATE_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open the Import dialog.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSystemBackupUploadModal(command, envelope) {
	return openResourceModal(
		SYSTEM_BACKUP_UPLOAD_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open the restore confirmation for the resolved System Backup row.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSystemBackupRestoreModal(command, envelope) {
	return openResourceModal(
		SYSTEM_BACKUP_RESTORE_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open the delete confirmation for the resolved System Backup row(s).
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSystemBackupDeleteModal(command, envelope) {
	return openResourceModal(
		SYSTEM_BACKUP_DELETE_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Report a System Backup modal outcome.
 * @param {'modal.cancelled'|'modal.saved'|'modal.failed'} eventType lifecycle event
 * @param {string|null} [errorCode] failure reason when the save did not complete
 * @return {Promise<object|null>} agent response
 */
export function reportSystemBackupModalLifecycle(eventType, errorCode = null) {
	return reportActiveAgentModalLifecycle(eventType, errorCode);
}
